import { createContext, useState } from "react";

import { type SticksProductDetailsProps } from "@product-details/containers/SticksProductDetailsContainer";
import { SticksProductUnavailable } from "@product-details/containers/SticksProductDetailsContainer/components";
import type {
  FallbackProductsSkus,
  SticksMap,
  SticksProductWithAggregations,
} from "@product-details/containers/SticksProductDetailsContainer/types";

export type SticksDataContextType = {
  data: SticksProductDetailsProps;
  setCurrentSKU: (newCurrentSKU: string) => void;
  currentProduct: SticksProductWithAggregations;
  fallbackProductsSkus: FallbackProductsSkus;
};

export const SticksDataContext = createContext<SticksDataContextType | undefined>(undefined);

export type SticksDataProviderProps = SticksProductDetailsProps & {
  children: React.ReactNode;
  sticksMap: SticksMap;
  fallbackProductsSkus: FallbackProductsSkus;
};

export const SticksDataProvider = ({
  children,
  sticksMap,
  fallbackProductsSkus,
  ...props
}: SticksDataProviderProps) => {
  const [contextData, setContextData] = useState<SticksProductDetailsProps>(props);

  const setCurrentSKU = (sku: string) => {
    setContextData((prevValue) => ({ ...prevValue, sku }));
  };

  const currentProduct = sticksMap.get(contextData.sku);

  if (!currentProduct) return <SticksProductUnavailable />;

  const contextValue = {
    data: contextData,
    setCurrentSKU,
    currentProduct,
    fallbackProductsSkus,
  } satisfies SticksDataContextType;

  return <SticksDataContext.Provider value={contextValue}>{children}</SticksDataContext.Provider>;
};
